import Highlight from '@tiptap/extension-highlight';
import { Link } from '@tiptap/extension-link';
import { Typography } from '@tiptap/extension-typography';
import { StarterKit } from '@tiptap/starter-kit';
export const tiptapExtensions = [
    StarterKit.configure({
        history: false,
    }),
    Link.configure({
        autolink: true,
        openOnClick: 'whenNotEditable',
    }),
    Typography,
    Highlight.configure({
        multicolor: true,
    }),
];
/**
 * Condenses rich text into plain text.
 */
export function tiptapToString(content, length) {
    const ctx = { length };
    const untrimmed = tiptapToStringRecursive(content, '', ctx);
    return length !== undefined && untrimmed.length > length ?
        untrimmed.substring(0, length) + '...'
        : untrimmed;
}
function tiptapToStringRecursive(content, snippet, ctx) {
    var _a;
    if (ctx.length !== undefined && ctx.length <= 0) {
        return snippet;
    }
    (_a = content.content) === null || _a === void 0 ? void 0 : _a.forEach((node) => {
        var _a;
        const text = node === null || node === void 0 ? void 0 : node.text;
        if (text) {
            snippet += text + ' ';
            if (ctx.length !== undefined) {
                ctx.length -= text.length + 1;
            }
        }
        else if ((_a = node === null || node === void 0 ? void 0 : node.content) === null || _a === void 0 ? void 0 : _a.length) {
            snippet = tiptapToStringRecursive(node, snippet, ctx);
        }
    });
    return snippet;
}
//# sourceMappingURL=tiptap.js.map